;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('inputRadio', inputRadio)

  /* @ngInject */
  function inputRadio () {
    return {
      restrict: 'E',
      scope: {
        label: '@',
        description: '@',
        modelPropertyName: '@',
        model: '=',
        value: '<',
        disabled: '<',
        mandatory: '<',
        readOnly: '<',
        options: '<',
        change: '='
      },
      templateUrl: '/core/directives/input-radio/input-radio-directive.html?$$REVISION$$',
      controller: 'InputRadioController'
    }
  }
})()
